import cardBase from './userCardList/userCardRow/homeCard/cardBase/cardBase';
import cardRequestDays from './userCardList/userCardRow/homeCard/cardRequestDays/cardRequestDays';
import cardRequestSuccess from './userCardList/userCardRow//homeCard/cardRequestSuccess/cardRequestSuccess';
import cardRequestFailure from './userCardList/userCardRow/homeCard/cardRequestFailure/cardRequestFailure';
import cardAvatar from './userCardList/userCardRow/homeCard/cardAvatar/cardAvatar';
import benefitRequestList from './benefitRequestList/benefitRequestList';
import benefitRequestCard from './benefitRequestList/benefitRequestCard/benefitRequestCard';
import benefitRequestModal from './benefitRequestModal/benefitRequestModal';
import userCardList from './userCardList/userCardList';
import userCardRow from './userCardList/userCardRow/userCardRow';
import lastDayAlert from './lastDayAlert/lastDayAlert';
import benefitRequestDays from './benefitRequestDays/benefitRequestDays';
import delegatedCardListMobile from './delegatedCardListMobile/delegatedCardListMobile';
import delegatedCardRow from './delegatedCardListMobile/delegatedCardRow/delegatedCardRow';
import delegatedCardAvatar from './delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardAvatar/delegatedCardAvatar';
import delegatedCardRequest from './delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequest/delegatedCardRequest';
import delegatedCardRequestCounter from './delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequestCounter/delegatedCardRequestCounter';
import delegatedRequestModal from './delegatedRequestModal/delegatedRequestModal';
import workTeamList from './workTeamList/workTeamList';
import workTeamCard from './workTeamList/workTeamCard/workTeamCard';

let foodBenefitComponents = angular.module('food-benefit.components', [
  cardBase,
  cardAvatar,
  cardRequestDays,
  benefitRequestList,
  benefitRequestCard,
  cardRequestSuccess,
  cardRequestFailure,
  benefitRequestModal,
  userCardList,
  userCardRow,
  lastDayAlert,
  benefitRequestDays,
  delegatedCardListMobile,
  delegatedCardRow,
  delegatedCardAvatar,
  delegatedCardRequest,
  delegatedCardRequestCounter,
  delegatedRequestModal,
  workTeamList,
  workTeamCard
])
  .name;

export default foodBenefitComponents;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/food-benefit.components.js